import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';
import { DataHandler, StorageHandler, APIHandler, Image, SharingPopup } from 'C4';
import { storageKeys } from 'settings';

const trackShare = (type, value, title) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest'; 
      if (userObj && userObj) {
        ({ email } = userObj);
      }    
      APIHandler.trackEvent(appId, email, 'collateral', type, value, title).then(() => {
      });
    });
  });
};

const Collection = (props) => {
  const { content, header } = props;

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(content).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = (url, image, title) => ({
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'x',
    },
    baseClass: 'customBox',
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={url} image={image} title={title} />),
    },
    caption: title,
  });

  return (
    <div className="collection__Container">
      <div className="collection__Container--title">
        <h3>{header}</h3>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
          ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
          : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
      >
        {styles => (
          <div className="collection__Grid">
            {Object.values(content).map((item, index) => {
              const {
                pageID, image, title, url, type,
              } = item;
              if (type === 'pdf') {
                return (
                  <div
                    className="collection_Card"
                    key={pageID}
                    style={{ opacity: `${styles[index].pos}` }}
                    href={`https://stack.travpromobile.com/viewer.php?file=${url}`}
                    data-fancybox={`https://stack.travpromobile.com/viewer.php?file=${url}`}
                    data-options={JSON.stringify(fancyOptions(`https://stack.travpromobile.com/viewer.php?file=${url}`, image, title))}
                    data-caption={title}
                    onClick={() => trackShare(url, url, title)}
                  >
                    <Image
                      key={url}
                      src={image}
                      gradient
                      onLoad={() => { this.setState({ loading: false }); }}
                    />
                    <div className="title">{title}</div>
                  </div>
                );
              }

              if (type === 'weblink') {
                return (
                  <div className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                    <a href={url} target="_blank" rel="noreferrer noopener" onClick={() => trackShare(url, url, title)}>
                      <Image
                        key={url}
                        src={image}
                        gradient
                        onLoad={() => { this.setState({ loading: false }); }}
                        href={url}
                      />
                      <div className="title">{title}</div>
                    </a>
                  </div>
                );
              }

              return (
                <div
                  className="collection_Card"
                  key={pageID}
                  style={{ opacity: `${styles[index].pos}` }}
                  data-options={JSON.stringify(fancyOptions(url, image, title))}
                  data-caption={title}
                  onClick={() => trackShare(url, url, title)}
                  href={url}
                  data-fancybox={url}
                >
                  <Image
                    key={url}
                    src={image}
                    gradient
                    onLoad={() => { this.setState({ loading: false }); }}
                  />
                  <div className="title">{title}</div>

                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default Collection;

Collection.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  header: PropTypes.string,
};

Collection.defaultProps = {
  header: '',
};
